export default __webpack_public_path__ + "static/soc-centrai-pagrindinis-b57691622b3caed884a76efe778e2dd6.png";